import React, { useMemo } from "react";
import objectPath from "object-path";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { useNavigate } from "react-router-dom";
import { UserNotificationsDropdown } from "../extras/dropdowns/UserNotificationsDropdown";
import { QuickUserToggler } from "../extras/QuiclUserToggler";
import { getDemoMode } from "../../../../helpers";
import GlobalSearch from "../extras/offcanvas/global-search/GlobalSearch";

// import { ConnectWallet } from "./header-menu/ConnectWallet";
import { ConnectWallet } from "./header-menu/ConnectWallet";
import { useSelector } from "react-redux";

export function Topbar() {
  let demoMode = getDemoMode();
  const navigate = useNavigate();
  const uiService = useHtmlClassService();
  const siteSetting = useSelector((state) => state.settings.generalSettings);
  const { currentPermissions } = useSelector((state) => state.role);
  const { generalSettings } = useSelector((state) => state.settings);
  const { taxonomy } = useSelector((state) => state?.taxonomy);
  const layoutProps = useMemo(() => {
    return {
      viewSearchDisplay: objectPath.get(
        uiService.config,
        "extras.search.display"
      ),
      viewNotificationsDisplay: objectPath.get(
        uiService.config,
        "extras.notifications.display"
      ),
      viewQuickActionsDisplay: objectPath.get(
        uiService.config,
        "extras.quick-actions.display"
      ),
      viewCartDisplay: objectPath.get(uiService.config, "extras.cart.display"),
      viewQuickPanelDisplay: objectPath.get(
        uiService.config,
        "extras.quick-panel.display"
      ),
      viewLanguagesDisplay: objectPath.get(
        uiService.config,
        "extras.languages.display"
      ),
      viewUserDisplay: objectPath.get(uiService.config, "extras.user.display"),
      viewAdminDisplay: objectPath.get(
        uiService.config,
        "extras.admin.display"
      ),
    };
  }, [uiService]);

  return (
    <div>
      {demoMode === "true" ? (
        <div
          className="pull-left pt-7 pe-2 ps-2"
          style={{
            fontWeight: "bold",
            fontSize: "12px",
            color: "white",
            backgroundColor: "#6048fe",
          }}>
          This demo is in sandbox mode and you will have limited access to the
          admin panel options. Have a question?{" "}
          <a
            className="text-warning fw-bold"
            href="http://www.fundraisingscript.com/contact_us.php"
            target="_blank">
            Contact Us
          </a>
        </div>
      ) : (
        ""
      )}
      <div className="topbar d-flex gap-2 align-items-center gap-sm-5">
        <GlobalSearch
          permissions={currentPermissions}
          generalSettings={generalSettings}
          taxonomy={taxonomy}
          navigate={navigate}
        />

        {siteSetting.paymentMethod === "crypto-payment" && <ConnectWallet />}
        {layoutProps.viewNotificationsDisplay && <UserNotificationsDropdown />}
        {layoutProps.viewUserDisplay && <QuickUserToggler />}
      </div>
    </div>
  );
}
